import Axios from './baseApi';

export default {
  addOrUpdateSummaryAddition(factoryId, form) {
    return Axios.post(`/api-master-data/factory-default-summary-additions/v1/${factoryId}`,
      form);
  },
  async fetchAll() {
    return await Axios.get('/api-master-data/v1/factory');
  },
  async fetch(id) {
    return await Axios.get('/api-master-data/v1/factory/' + id);
  },
  fetchSlaughters() {
    return Axios.post('/api-master-data/v1/factory/slaughter/overview', {});
  },
  fetchVeterinarians() {
    return Axios.post('/api-master-data/v1/factory/veterinarian/overview', {});
  },
  fetchSummaryAdditions(factoryId) {
    return Axios.get(`/api-master-data/factory-default-summary-additions/v1/${factoryId}`);
  },
  async create(factory) {
    return await Axios.put(`/api-master-data/v1/factory`, factory);
  },
  async update(factory) {
    return await Axios.post('/api-master-data/v1/factory', factory);
  },
  async delete(id) {
    return await Axios.delete(`/api-master-data/v1/factory/${id}`);
  },
  async search(query) {
    return await Axios.get('/api-master-data/v1/factory/search?query=' + query);
  },
}
